var _circle, _path, _path2, _path3, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 49.9995,
    r: 50,
    fill: "#FDE0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8145 30.8001C47.3295 29.8127 48.087 29.319 48.9031 29.1269C49.6246 28.9571 50.3754 28.9571 51.0969 29.1269C51.913 29.319 52.6705 29.8127 54.1855 30.8001L72.2528 42.5758C72.8912 42.9919 73.2104 43.1999 73.4417 43.4774C73.6464 43.7231 73.8002 44.0072 73.894 44.3132C74 44.6589 74 45.0407 74 45.8042V63.4482C74 67.4915 74 69.5132 73.2152 71.0575C72.525 72.416 71.4235 73.5205 70.0687 74.2126C68.5286 74.9995 66.5124 74.9995 62.48 74.9995H37.52C33.4876 74.9995 31.4714 74.9995 29.9313 74.2126C28.5765 73.5205 27.475 72.416 26.7848 71.0575C26 69.5132 26 67.4915 26 63.4482V45.8042C26 45.0407 26 44.6589 26.106 44.3132C26.1998 44.0072 26.3536 43.7231 26.5584 43.4774C26.7896 43.1999 27.1088 42.9919 27.7472 42.5758L45.8145 30.8001Z",
    fill: "#FFA6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8145 56.629L30.9533 46.943C29.3024 45.867 28.477 45.329 28.1911 44.6468C27.9413 44.0505 27.4974 43.172 27.7472 42.5758C28.5194 42.0725 29.3024 41.5621 30.9533 40.4862L45.8145 30.8001C47.3295 29.8127 48.087 29.319 48.9031 29.1269C49.6246 28.9571 50.3754 28.9571 51.0969 29.1269C51.913 29.319 52.6705 29.8127 54.1855 30.8001L69.0467 40.4862C70.6976 41.5621 71.523 42.1001 71.8089 42.7824C72.0587 43.3786 72.0587 44.0505 71.8089 44.6468C71.523 45.329 70.6976 45.867 69.0467 46.943L54.1855 56.6291C52.6705 57.6165 51.913 58.1102 51.0969 58.3023C50.3754 58.4721 49.6246 58.4721 48.9031 58.3023C48.087 58.1102 47.3295 57.6165 45.8145 56.629Z",
    fill: "#FFA6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1855 30.8001L72.2528 42.5758C72.8912 42.9919 73.2104 43.1999 73.4416 43.4774C73.6464 43.7231 73.8002 44.0072 73.894 44.3132C74 44.6589 74 45.0407 74 45.8042V63.4481C74 67.4915 74 69.5132 73.2152 71.0575C72.525 72.416 71.4235 73.5205 70.0687 74.2126C68.5286 74.9995 66.5124 74.9995 62.48 74.9995H37.52C33.4876 74.9995 31.4714 74.9995 29.9313 74.2126C28.5765 73.5205 27.475 72.416 26.7848 71.0575M54.1855 30.8001C52.6705 29.8127 51.913 29.319 51.0969 29.1269C50.3754 28.9571 49.6246 28.9571 48.9031 29.1269C48.087 29.319 47.3295 29.8127 45.8145 30.8001M54.1855 30.8001L69.0467 40.4862C70.6976 41.5621 71.523 42.1001 71.8089 42.7824C72.0587 43.3786 72.0587 44.0505 71.8089 44.6468C71.523 45.329 70.6976 45.867 69.0467 46.943L54.1855 56.6291M45.8145 30.8001L27.7472 42.5758M45.8145 30.8001L30.9533 40.4862C29.3024 41.5621 28.5194 42.0725 27.7472 42.5758M27.7472 42.5758C27.1088 42.9919 26.7896 43.1999 26.5584 43.4774C26.3536 43.7231 26.1998 44.0072 26.106 44.3132C26 44.6589 26 45.0407 26 45.8042V63.4481C26 67.4915 26 69.5132 26.7848 71.0575M27.7472 42.5758C27.4974 43.172 27.9413 44.0505 28.1911 44.6468C28.477 45.329 29.3024 45.867 30.9533 46.943L45.8145 56.629M26.7848 71.0575L45.8145 56.629M45.8145 56.629C47.3295 57.6165 48.087 58.1102 48.9031 58.3023C49.6246 58.4721 50.3754 58.4721 51.0969 58.3023C51.913 58.1102 52.6705 57.6165 54.1855 56.6291M54.1855 56.6291L72.8 70.1864",
    stroke: "url(#paint0_linear_501_45036)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_501_45036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 38.4254L50 49.1662M50 49.1662L60 38.4254M50 49.1662V24.9995",
    stroke: "#F24848",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_501_45036",
    x: 36.5,
    y: 21.4995,
    width: 29,
    height: 33.1665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.0392157 0 0 0 0 0.109804 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_501_45036"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_501_45036",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_501_45036",
    x1: 26,
    y1: 28.9995,
    x2: 74.8184,
    y2: 29.8851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/Inbox.759674869725d054da814124a422c249.svg";
export { ForwardRef as ReactComponent };